const pageView = {
  event: 'homeRendered',
}

export default pageView
